import administration from './administration';
import trainer from './trainer';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [...administration, ...trainer]
};

export default menuItems;
